import { render, staticRenderFns } from "./FertiliserManager.vue?vue&type=template&id=4fa855e0&"
import script from "./FertiliserManager.vue?vue&type=script&lang=js&"
export * from "./FertiliserManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FertiliserManager.vue"
export default component.exports